"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HandsFree {
    /**
     * @method call: Function to use to Contents calling function of Hands-free
     * App that makes a call to specified tel number
     * @param tel phone number without special caracters, should be string format
     * @param prefix If true will add '+', tel should be number and country code would be needed,
     * if false number can be string with full value ex: +112345667890 and countryCode wont be needed
     * @param countryCode if need to specify a country code
     * @Return schema for calling
     */
    static callNumber(tel, prefix, countryCode) {
        let schema = '';
        if (prefix) {
            schema = `tel:+${countryCode}${tel}`;
        }
        else {
            schema = `tel:${tel}`;
        }
        return schema;
    }
}
exports.default = HandsFree;
//# sourceMappingURL=HandsFree.js.map